module.exports = __webpack_public_path__ + "img/Underreview.cd025646.png";